import { doFetch } from "./fetch"

export type CreateMessageData = {
  toUserIds: number[]
  toDistrictIds?: number[]
  content: string
  attachments: File[]
  systemMessage?: boolean
}

export interface UpdateMessageData {
  content?: string
  systemMessage?: boolean
}

export const messagesApi = {
  getMessages: () => {
    return doFetch(`/api/messages`)
  },
  getMyMessages: () => {
    return doFetch(`/api/messages/my`)
  },
  getMessage: (id: number) => {
    return doFetch(`/api/messages/${id}`)
  },
  markAsRead: (messageId: number) => {
    return doFetch(`/api/messages/read`, {
      method: "POST",
      body: { messageId },
    })
  },
  createMessage: (body: CreateMessageData) => {
    const formData = new FormData()
    formData.append("content", body.content)
    formData.append("systemMessage", body.systemMessage?.toString() || "false")
    body.toUserIds.forEach((userId) => {
      formData.append("toUserIds[]", userId.toString())
    })
    body.toDistrictIds?.forEach((districtId) => {
      formData.append("toDistrictIds[]", districtId.toString())
    })
    body.attachments.forEach((attachment) => {
      formData.append("attachments[]", attachment)
    })

    return doFetch(`/api/messages`, {
      body: formData,
      method: "POST",
    })
  },
  updateMessage: (id: number, body: UpdateMessageData) => {
    return doFetch(`/api/messages/${id}`, {
      body,
      method: "PATCH",
    })
  },
  deleteMessage: (id: number) => {
    return doFetch(`/api/messages/${id}`, {
      method: "DELETE",
    })
  },
}
